/* eslint-disable import/prefer-default-export */

export const SUCCESSION_READINESS_UPDATE = 'SUCCESSSION_READINESS_UPDATE';
export const SUCCESSION_READINESS_REFETCH = 'SUCCESSION_READINESS_REFETCH';